import { ConsumerHandlerContext } from '@exploring-infinities/meet';
import { Outlet } from 'react-router';
import '@exploring-infinities/meet/style.css';

import useConsumerHandlerData from '@/hooks/use-consumer-handler-data';

export default function MaverickLayout() {
  const consumerHandlerData = useConsumerHandlerData();
  return (
    <ConsumerHandlerContext.Provider value={consumerHandlerData}>
      <div className="meet-container h-full w-full m-0 fixed top-0 left-0 overscroll-y-none">
        <Outlet />
      </div>
    </ConsumerHandlerContext.Provider>
  );
}
